// extracted by mini-css-extract-plugin
export default {"fileInputContainer":"styles_fileInputContainer__9fdxs","label":"styles_label__C27W7"};